import { useEffect } from "react";
import { X, Check } from "lucide-react";
import { Reveal, Eyebrow } from "../components/Reveal";
import { HiFinalCta, HI_QUESTIONS, HI_DONT, HI_DO, HI_PROCESS } from "./HindiHome";

const HindiWhyAlbl = () => {
    useEffect(() => {
        document.title = "ALBL क्यों | कोई और डिजिटल मार्केटिंग एजेंसी नहीं — नर्मदापुरम और इतारसी";
    }, []);

    return (
        <main lang="hi">
            <section className="bg-[#0D131F] hero-grid text-white pt-32 sm:pt-40 pb-16 sm:pb-24">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
                    <Reveal>
                        <Eyebrow dark>ALBL क्यों</Eyebrow>
                        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.15] mt-5 max-w-4xl" data-testid="hi-why-hero-heading">
                            आपको एक और मार्केटिंग एजेंसी नहीं चाहिए।
                        </h1>
                        <p className="mt-6 text-slate-400 text-base sm:text-lg max-w-2xl leading-relaxed">
                            ज़्यादातर एजेंसियां आपको पोस्ट, रील्स, वेबसाइट और &quot;डिजिटल मार्केटिंग&quot; बेचती हैं। ALBL की शुरुआत कहीं और से होती है — बिज़नेस से।
                        </p>
                    </Reveal>
                </div>
            </section>

            <section className="bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20 sm:py-28 grid lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-5">
                        <Reveal>
                            <Eyebrow>पहले हम इनका जवाब ढूंढते हैं</Eyebrow>
                            <div className="gold-rule mt-6" />
                        </Reveal>
                    </div>
                    <div className="lg:col-span-7">
                        <Reveal delay={100}>
                            <div className="grid sm:grid-cols-2 gap-3">
                                {HI_QUESTIONS.map((q, i) => (
                                    <div key={q} className="border border-slate-200 bg-[#F8FAFC] px-5 py-5">
                                        <span className="font-serif-accent italic text-[#C5A059] text-lg">0{i + 1}</span>
                                        <p className="mt-1 text-sm sm:text-base text-slate-800 font-medium">{q}</p>
                                    </div>
                                ))}
                            </div>
                            <p className="mt-8 text-slate-600 text-base sm:text-lg leading-relaxed">
                                पहले हम इन सवालों के जवाब ढूंढते हैं।{" "}
                                <span className="text-slate-900 font-semibold">
                                    फिर बिज़नेस के अनुसार मार्केटिंग बनाते हैं।
                                </span>
                            </p>
                        </Reveal>
                    </div>
                </div>
            </section>

            <section className="bg-[#0D131F] text-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20 sm:py-28 grid lg:grid-cols-2 gap-14">
                    <Reveal>
                        <h2 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight leading-[1.15]" data-testid="hi-why-dont-heading">
                            हम क्या नहीं करते।
                        </h2>
                        <ul className="mt-10 space-y-5">
                            {HI_DONT.map((item) => (
                                <li key={item} className="flex gap-4 items-start">
                                    <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center border border-red-400/50">
                                        <X className="h-3 w-3 text-red-400" />
                                    </span>
                                    <span className="text-slate-300 text-sm sm:text-base">{item}</span>
                                </li>
                            ))}
                        </ul>
                    </Reveal>
                    <Reveal delay={150}>
                        <h2 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight leading-[1.15] text-[#C5A059]">
                            हम क्या करते हैं।
                        </h2>
                        <ul className="mt-10 space-y-5">
                            {HI_DO.map((item) => (
                                <li key={item} className="flex gap-4 items-start">
                                    <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center border border-[#C5A059]/60">
                                        <Check className="h-3 w-3 text-[#C5A059]" />
                                    </span>
                                    <span className="text-slate-200 text-sm sm:text-base">{item}</span>
                                </li>
                            ))}
                        </ul>
                    </Reveal>
                </div>
            </section>

            <section className="bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20 sm:py-28">
                    <Reveal>
                        <Eyebrow>हम कैसे काम करते हैं</Eyebrow>
                        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900 leading-[1.15] mt-5">
                            कोई कॉपी-पेस्ट मार्केटिंग नहीं।
                        </h2>
                    </Reveal>
                    <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-slate-200 border border-slate-200">
                        {HI_PROCESS.map((p) => (
                            <div key={p.num} className="bg-white p-8">
                                <span className="font-serif-accent italic text-3xl text-[#C5A059]">{p.num}</span>
                                <h3 className="font-display text-xl font-bold text-slate-900 tracking-tight mt-4">{p.title}</h3>
                                <p className="mt-3 text-sm text-slate-600 leading-relaxed">{p.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <HiFinalCta />
        </main>
    );
};

export default HindiWhyAlbl;
